import {
  buildLotUserContentCommercialSummary,
  hasLotUserContentCommercialData,
} from './lotUserContentFormUtils';

const getDescription = (content) => String(content?.description ?? content?.notes ?? '').trim();

/**
 * Ítems visibles para el visitante (siempre que haya datos).
 * @param {object|null|undefined} content - data de GET /getlotusercontent
 */
export const buildLotUserContentSharePreview = (content) => {
  if (!content) return [];

  const items = [];

  if (String(content.title || '').trim()) {
    items.push({
      key: 'title',
      label: 'Título',
      value: String(content.title).trim(),
    });
  }

  const description = getDescription(content);
  if (description) {
    items.push({
      key: 'description',
      label: 'Descripción',
      value: description,
    });
  }

  if (hasLotUserContentCommercialData(content)) {
    const commercial = buildLotUserContentCommercialSummary(content);
    if (commercial) {
      items.push({
        key: 'commercial',
        label: 'Datos comerciales',
        value: commercial,
      });
    }
  }

  const images = Array.isArray(content.images) ? content.images : [];
  if (images.length > 0) {
    items.push({
      key: 'photos',
      label: images.length === 1 ? '1 foto' : `${images.length} fotos`,
      value: null,
    });
  }

  const videos = Array.isArray(content.videos) ? content.videos : [];
  if (videos.length > 0) {
    items.push({
      key: 'videos',
      label: videos.length === 1 ? '1 video' : `${videos.length} videos`,
      value: null,
    });
  }

  const attachments = Array.isArray(content.attachments) ? content.attachments : [];
  if (attachments.length > 0) {
    items.push({
      key: 'attachments',
      label: attachments.length === 1 ? '1 adjunto' : `${attachments.length} adjuntos`,
      value: null,
    });
  }

  return items;
};

/** Terrio parcela siempre visible con JWT en share. */
export const TERIO_PARCEL_SHARE_ITEM = {
  key: 'terrio',
  label: 'Información catastral (Terrio)',
  value: 'Siempre incluida',
};
